import * as React from 'react';
import { LibraryCard, CardProperties } from '../../../types/LibraryCard';
import EditBookCard from '../../EditBookCard/EditBookCard';
import { Book } from '../../../types/Book';
import getBook from '../../../requests/getBook';
import getLibraryCard from '../../../requests/getLibraryCard';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
	bookExternalId?: string;
	bookWooId?: number;
	onSaved?: () => void;
	saveCard: (card: LibraryCard) => Promise<number>;
	saveProperties: (cardId: number, properties: CardProperties) => Promise<boolean>;
	onClose?: () => void;
}

export const Inner: React.FunctionComponent<Props> = props => {
	const [isLoading, setLoading] = React.useState(false);
	const [book, setBook] = React.useState<Book>();
	const [libraryInfo, setLibraryInfo] = React.useState<LibraryCard>(null);

	React.useEffect(() => {
		setLoading(true);

		const request = async () => {
			const data = props.bookWooId ? await getBook(props.bookWooId as any, true) : await getBook(props.bookExternalId);

			if (data && data.externalId) {
				setBook(data);

				if (data.cardId) {
					const library = await getLibraryCard(data.cardId);

					if (library) {
						setLibraryInfo(library);
					}
				}

				setLoading(false);
			}
		};

		request();
	}, [props.bookExternalId]);

	return <div>
		{isLoading && <div>
			<CircularProgress />
		</div>}

		{!isLoading && book && <EditBookCard
			libraryCard={libraryInfo}
			book={book}
			onSaved={props.onSaved}
			saveCard={props.saveCard}
			saveProperties={props.saveProperties}
			onClose={props.onClose}
		/>}
	</div>;
};

export default Inner;
